import {ModalService} from "../controllers/geoapp";
import type {L} from "../lt-ng/landcare-toolkit";

class TileErrorModalController {
    resolve: {layer: L.util.LayerService} = null;

    constructor(protected $uibModal: ModalService, protected $http: ng.IHttpService) {

    }

    public contentRequest: ng.IPromise<string> = null;
    public _content: string = 'loading more information...';

    public content(): string {
        this.contentRequest = this.contentRequest || this.$http
            .get(window.location.pathname + '/layerErrorModal', {cache: true})
            .then(resp => {
                if (resp.status >= 200 && resp.status < 400) {
                    return this._content = <string> resp.data;
                } else {
                    return '';
                }
            }, () => {
                return this._content = 'failed to load more info...';
            });

        return this._content;
    }

    public layerName() {
        return this.resolve.layer && this.resolve.layer.description;
    }
}

export class TileErrorModalComponent implements ng.IComponentOptions {
    public controller = ['$uibModal', '$http', TileErrorModalController];

    public bindings = {
        resolve: '<',
        close: '&',
        dismiss: '&'
    };

    public template = `<div class="modal-header">
        <h3 class="modal-title">Map tile errors</h3>
    </div>
    <div class="modal-body settings-modal">
        <p>
            It has been detected that <b>{{ $ctrl.layerName() }}</b> map tiles have failed to load.
        </p>
       <div ng-bind-html="$ctrl.content()"></div>
    </div>
    <div class="modal-footer">
        <button class="btn-rounded btn-cancel btn-default" type="button" ng-click="$ctrl.dismiss()" data-action="dismissModal">Dismiss</button>
    </div>`
}
